var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgImagine = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 79,
    viewBox: "0 0 140 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9641_967",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 140,
    height: 79
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 78.2609,
    rx: 8,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9641_967)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.348 82.6087C138.601 82.6087 158.261 62.9481 158.261 38.6956C158.261 14.4431 138.601 -5.21741 114.348 -5.21741C90.0956 -5.21741 70.8698 8.35618 70.8698 32.6087C70.8698 39.9449 75.2176 58.2609 96.9568 76.5217",
    stroke: "#C7AAFA",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.174 68.2608C106.522 67.3913 102.898 64.2028 100.869 62.6086C100.869 66.5217 104.261 72.5217 110.869 73.913C117.478 75.3043 123.478 70.7246 124.782 67.3913C122.608 68.2608 117.826 69.1304 112.174 68.2608Z",
    stroke: "#7F39FA",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2036 40.1068C85.5514 50.1069 95.9861 57.1502 103.812 54.0199C108.404 52.1831 110.901 47.1131 111.301 41.3042C111.584 37.213 110.826 32.7553 109.03 28.8025C104.682 19.2374 94.6821 14.8894 87.7253 17.9329C82.3513 20.2839 78.7937 26.2674 79.4574 33.4782",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.369 51.6143C147.008 55.3898 142.401 58.1108 137.94 59.1764C133.463 60.2456 129.323 59.6171 126.644 57.0006C123.939 54.3586 122.994 50.1609 123.689 45.5116C124.382 40.878 126.691 35.9568 130.252 32.0878C137.331 24.3955 146.635 24.4439 151.757 29.1359C156.838 33.7913 157.105 44.0486 150.369 51.6143Z",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_9641_967)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.25,
    y: 1.25,
    width: 137.5,
    height: 75.7609,
    rx: 6.75,
    stroke: "#C7AAFA",
    strokeWidth: 2.5
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_9641_967",
    x: -11,
    y: -11,
    width: 162,
    height: 100.261,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_9641_967"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.780392 0 0 0 0 0.666667 0 0 0 0 0.980392 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9641_967"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9641_967",
    result: "shape"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgImagine);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/imagine.2294b52a0bb81aefea8877d723202f4e.svg";